import { Grid } from "@material-ui/core";
import { useRouter } from "@uirouter/react";
import { noop } from "lodash";
import { FunctionComponent, useCallback } from "react";
import { DangerButton } from "../../../../../components/button";
import { useAppLoader } from "../../../../../components/loader/app-loader-hook";
import { UsersService } from "../../../../../store/users/service";

export const RemoveUserModal: FunctionComponent<{
  userReferenceId: string;
  delegateUserId: string;
}> = ({ delegateUserId, userReferenceId }) => {
  const router = useRouter();
  const loader = useAppLoader();

  const removeDelegateUser = useCallback(() => {
    loader(UsersService.removeDelegateUser(userReferenceId, delegateUserId))
      .then(() => router.stateService.reload())
      .catch(noop);
  }, [loader, router, userReferenceId, delegateUserId]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        Are you sure you want to Remove Delegate User?
      </Grid>
      <Grid item xs={12}>
        <DangerButton fullWidth onClick={removeDelegateUser}>
          Delete
        </DangerButton>
      </Grid>
    </Grid>
  );
};
